import { render } from "./login-page.vue?vue&type=template&id=94dc31fc"
import script from "./login-page.vue?vue&type=script&lang=js"
export * from "./login-page.vue?vue&type=script&lang=js"

import "./login-page.vue?vue&type=style&index=0&id=94dc31fc&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__